import Axios from 'helpers/Interceptor';
import * as Sentry from '@sentry/react';

/** Type definition for a presave record */
export type Presave = {
  contentName: string;
  artistName: string;
  imageUrl: string;
  type: string;
}


/** Response type for forever pre-saves update */
interface ForeverPreSavesResponse {

    success: boolean;
}

/**
 * Fetches all pre-saves associated with a specific fan
 * @async
 * @param {number} fanId - ID of the fan to fetch pre-saves for
 * @returns {Promise<{ data: Presave[] | null, error: Error | null }>} Pre-saves data or error
 */
export const getPresavedByFan_api = async (fanId: number) => {
  try {
    const response = await Axios.get<Presave[]>(`fan/${fanId}/pre_saves`);
    return { data: response.data, error: null };
  } catch (error) {
    Sentry.captureException(error);
    return { data: null, error };
  }
};

/**
 * Updates the forever pre-saves setting for a fan
 * @async
 * @param {Object} params - Parameters for updating forever pre-saves
 * @param {number} params.fanId - ID of the fan to update
 * @param {boolean} params.activate - Whether to activate or deactivate forever pre-saves
 * @returns {Promise<{ data: { success: boolean } | null, error: Error | null }>} Update result or error
 */
export const setForeverPresaves_api = async (params: { fanId: number; activate: boolean }) => {
  const { fanId, activate } = params;
  try {
    const response = await Axios.put<ForeverPreSavesResponse>(`fan/${fanId}/forever_pre_saves`, {
      activate
    });
    return { data: response.data, error: null };
  } catch (error) {
    Sentry.captureException(error);
    return { data: null, error };
  }
}; 

/**
 * Forces forever saves for a given content and brand
 * @async
 * @param {string} contentSlug - The slug identifier for the content
 * @param {string} brandSlug - The slug identifier for the brand
 * @returns {Promise<{ data: any | null, error: Error | null }>} Response data or error
 */
export const forceForeverSaves_api = async (contentSlug: string, brandSlug: string) => {
  try {
    const response = await Axios.post('/fan-save/force/forever-fan-saves', {
      contentId: contentSlug,
      brandSlug
    });
    return { data: response.data, error: null };
  } catch (error) {
    Sentry.captureException(error);
    return { data: null, error };
  }
};

export const unsubscribe_api = async (email: string, brandId: string) => {
  try {
    const response = await Axios.post(`/unsubscribe?brandId=${brandId}&email=${email}`);
    return { data: response.data, error: null };
  } catch (error) {
    Sentry.captureException(error);
    return { data: null, error };
  }
}